import { useState, useMemo, useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { itemSchema } from "../validations/inventoryValidation";

export const DEFAULT_INVENTORY_VALUES = {
  name: "",
  sku: "",
  itemCode: "",
  category: "",
  unit: "",
  unitPrice: 0,
  minQty: 0,
  availableQty: 0,
  brand: "",
  type: "Stockable",
  businessUnit: "VENUS INFRA SERVICES",
  store: "",
  baseAmount: 0,
  discount: 0,
  igst: 0,
  sgst: 0,
  cgst: 0,
  chargeAmount: 0,
  adjustments: 0
};

export const useInventoryModalLogic = ({ activeTab, initialData, inventory, isOpen, onSubmit, onItemSelect }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors }
  } = useForm({
    resolver: zodResolver(itemSchema),
    defaultValues: initialData 
      ? { ...DEFAULT_INVENTORY_VALUES, ...initialData } 
      : { ...DEFAULT_INVENTORY_VALUES, serviceType: activeTab || "solar" }
  });

  const watchedValues = watch();

  useEffect(() => {
    if (isOpen) {
      if (initialData) {
        reset({ ...DEFAULT_INVENTORY_VALUES, ...initialData });
      } else {
        reset({ ...DEFAULT_INVENTORY_VALUES, serviceType: activeTab || "solar" });
      }
    }
  }, [isOpen, initialData, reset, activeTab]);

  const filteredItems = useMemo(() => {
    if (!searchTerm) return inventory;
    return inventory.filter(item =>
      (item.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.itemCode || "").toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [inventory, searchTerm]);

  const handleMasterSelect = (item) => {
    setValue('name', item.name || "");
    setValue('itemCode', item.itemCode || "");
    setValue('category', item.category || "");
    setValue('unit', item.unit || "");
    setValue('availableQty', item.availableQty || 0);
    setValue('unitPrice', item.unitPrice || 0);
    
    setSearchTerm(item.name || "");
    setShowDropdown(false);
    if (onItemSelect) onItemSelect(item._id);
  };

  const onFormSubmit = (data) => {
    const base = Number(data.baseAmount) || 0;
    const disc = Number(data.discount) || 0;
    const tax = (Number(data.igst) || 0) + (Number(data.sgst) || 0) + (Number(data.cgst) || 0);
    const netBill = (base - disc) + tax + (Number(data.chargeAmount) || 0);
    const netPayment = netBill + (Number(data.adjustments) || 0);

    onSubmit({
      ...data,
      taxAmount: tax,
      netBill: netBill,
      netPayment: netPayment
    });
  };

  return {
    searchTerm,
    setSearchTerm,
    showDropdown,
    setShowDropdown,
    filteredItems,
    handleMasterSelect,
    register,
    handleSubmit,
    errors,
    watchedValues,
    onFormSubmit
  };
};
